<div class="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-md animate-fade-in"
    (click)="closeDropdown()">
    <div class="absolute inset-0" (click)="onClose()"></div>

    <div class="bg-white dark:bg-slate-800 w-full max-w-2xl max-h-[90vh] rounded-[2.5rem] shadow-2xl flex flex-col relative animate-fade-in-up z-[110] overflow-hidden"
        (click)="$event.stopPropagation()">

        <!-- Header -->
        <div class="px-8 py-6 border-b border-slate-50 dark:border-slate-700 flex items-center justify-between bg-white dark:bg-slate-800 sticky top-0 z-20">
            <div class="flex items-center gap-4">
                <div class="w-12 h-12 rounded-2xl bg-amber-50 dark:bg-amber-900/20 flex items-center justify-center text-amber-500 shadow-sm border border-amber-100 dark:border-amber-800">
                    <span class="material-icons text-2xl">post_add</span>
                </div>
                <div>
                    <h2 class="text-xl font-black text-slate-800 dark:text-slate-100 tracking-tight">
                        {{ editItem ? 'แก้ไขรายการเอกสาร' : 'เพิ่มรายการเอกสาร' }}
                    </h2>
                    <p class="text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-widest mt-0.5">
                        {{ editItem ? 'Edit Item Information' : 'Add Item Information' }}
                    </p>
                </div>
            </div>

            <div class="flex items-center gap-3">
                <button (click)="onClose()"
                    class="px-6 py-2.5 rounded-xl text-slate-500 font-bold hover:bg-slate-100 dark:hover:bg-slate-700 transition-all text-xs">ยกเลิก</button>
                <button (click)="saveItem()" [disabled]="!newItemFeeId || newItemDescription.length < 2 || newItemQuantity < 1 || newItemAmount < 1"
                    class="px-8 py-2.5 bg-amber-400 hover:bg-amber-500 text-white font-black rounded-xl shadow-lg hover:-translate-y-0.5 transition-all flex items-center gap-2 text-xs disabled:opacity-50 disabled:transform-none">
                    {{ editItem ? 'บันทึกการแก้ไข' : 'ยืนยันการเพิ่มรายการ' }}
                </button>
            </div>
        </div>

        <!-- Form Area -->
        <div class="flex-1 overflow-y-auto p-12 custom-scrollbar">
            <div class="max-w-[420px] mx-auto space-y-8">

                <div class="space-y-6">
                    <!-- Fee Type Searchable Dropdown -->
                    <div class="space-y-2">
                        <label class="text-[11px] font-black text-slate-400 uppercase tracking-widest pl-1 mb-1.5 block">
                            รายการค่าธรรมเนียม (Fee Type)
                        </label>
                        <div class="relative" (click)="$event.stopPropagation()">
                            <button type="button" (click)="toggleDropdown($event)"
                                class="w-full h-11 px-4 flex items-center justify-between bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-700 rounded-xl text-sm font-bold text-slate-700 dark:text-slate-200 focus:bg-white dark:focus:bg-slate-800 focus:ring-4 focus:ring-amber-50 dark:focus:ring-amber-900/30 outline-none transition-all"
                                [ngClass]="{'ring-4 ring-amber-50 dark:ring-amber-900/30 border-amber-200 bg-white': isDropdownOpen}">
                                <span class="truncate" [ngClass]="newItemFeeId ? 'text-slate-700 dark:text-slate-200' : 'text-slate-400 font-normal'">
                                    {{ selectedFeeName || 'เลือกรูปแบบรายการ...' }}
                                </span>
                                <span class="material-icons text-slate-400 text-sm transition-transform" [ngClass]="{'rotate-180': isDropdownOpen}">expand_more</span>
                            </button>

                            <!-- Dropdown List -->
                            <div *ngIf="isDropdownOpen"
                                class="absolute top-full left-0 right-0 mt-2 z-[110] bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-2 animate-fade-in-up max-h-56 overflow-hidden flex flex-col">

                                <div class="px-3 pb-2 border-b border-slate-50 dark:border-slate-700/50 mb-1">
                                    <div class="relative">
                                        <input type="text" [(ngModel)]="searchFeeText" (input)="filterFees()" placeholder="ค้นหาตามชื่อรายการ..."
                                            class="w-full h-9 pl-8 pr-3 bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-700 rounded-lg text-xs font-bold outline-none focus:border-amber-400 transition-all">
                                        <span class="material-icons text-[14px] text-slate-400 absolute left-2.5 top-1/2 -translate-y-1/2">search</span>
                                    </div>
                                </div>

                                <div class="overflow-y-auto custom-scrollbar flex-1">
                                    <div *ngIf="filteredFeeList.length === 0" class="px-4 py-6 text-center">
                                        <p class="text-xs font-bold text-slate-400">ไม่พบข้อมูล</p>
                                    </div>
                                    <button *ngFor="let fee of filteredFeeList" (click)="selectFee(fee)"
                                        class="w-full text-left px-4 py-2.5 text-sm font-bold hover:bg-amber-50 dark:hover:bg-amber-900/20 hover:text-amber-600 dark:hover:text-amber-500 cursor-pointer transition-all border-l-4 border-transparent hover:border-amber-400"
                                        [ngClass]="{'bg-amber-50 text-amber-600 border-amber-400': newItemFeeId === fee.id}">
                                        {{ fee.name }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Description -->
                    <div>
                        <label class="text-[11px] font-black text-slate-400 uppercase tracking-widest pl-1 mb-1.5 block">
                            คำอธิบาย (Description)
                        </label>
                        <input type="text" [(ngModel)]="newItemDescription" placeholder="ใส่ชื่อรายการตามที่ต้องการ..."
                            class="w-full h-11 px-4 bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-700 rounded-xl text-sm font-bold text-slate-700 dark:text-slate-200 outline-none transition-all focus:bg-white dark:focus:bg-slate-800 focus:ring-4 focus:ring-amber-50 dark:focus:ring-amber-900/30">
                    </div>

                    <!-- VAT amount mode -->
                    <div *ngIf="selectedFeeHasVat">
                        <label class="text-[11px] font-black text-slate-400 uppercase tracking-widest pl-1 mb-1.5 block">
                            ยอดที่กรอก (VAT {{ vatRateLabel }}%)
                        </label>
                        <div class="flex items-center p-1 bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-700 rounded-xl h-11 shadow-sm">
                            <button type="button" (click)="setAmountMode('inclusive')"
                                class="flex-1 h-full rounded-lg text-xs font-black transition-all flex items-center justify-center gap-1.5"
                                [ngClass]="amountMode === 'inclusive'
                                    ? 'bg-white dark:bg-slate-700 text-amber-600 dark:text-amber-400 shadow-sm'
                                    : 'text-slate-400 hover:text-amber-600'">
                                <span class="material-icons text-[16px]">call_split</span>
                                รวม VAT แล้ว (ถอด VAT)
                            </button>
                            <div class="w-px h-4 bg-slate-200 dark:bg-slate-700 mx-1"></div>
                            <button type="button" (click)="setAmountMode('exclusive')"
                                class="flex-1 h-full rounded-lg text-xs font-black transition-all flex items-center justify-center gap-1.5"
                                [ngClass]="amountMode === 'exclusive'
                                    ? 'bg-white dark:bg-slate-700 text-amber-600 dark:text-amber-400 shadow-sm'
                                    : 'text-slate-400 hover:text-amber-600'">
                                <span class="material-icons text-[16px]">add_circle_outline</span>
                                ยังไม่รวม VAT (บวก VAT)
                            </button>
                        </div>
                    </div>

                    <!-- Qty and Price -->
                    <div class="grid grid-cols-2 gap-5">
                        <div>
                            <label class="text-[11px] font-black text-slate-400 uppercase tracking-widest pl-1 mb-1.5 block">
                                จำนวน (Qty)
                            </label>
                            <div class="relative flex items-center">
                                <input type="number" [(ngModel)]="newItemQuantity" min="1"
                                    class="w-full h-11 px-4 bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-700 rounded-xl text-center text-sm font-black text-slate-700 dark:text-slate-200 outline-none transition-all focus:ring-4 focus:ring-amber-50 focus:bg-white dark:focus:bg-slate-800">
                                <div class="absolute right-1 flex flex-col gap-0.5">
                                    <button (click)="newItemQuantity = newItemQuantity + 1" class="w-6 h-4 bg-white dark:bg-slate-800 border border-slate-100 dark:border-slate-700 rounded-md text-slate-400 hover:text-amber-500 flex items-center justify-center cursor-pointer transition-colors">
                                        <span class="material-icons text-[10px]">expand_less</span>
                                    </button>
                                    <button (click)="newItemQuantity = newItemQuantity > 1 ? newItemQuantity - 1 : 1" class="w-6 h-4 bg-white dark:bg-slate-800 border border-slate-100 dark:border-slate-700 rounded-md text-slate-400 hover:text-rose-500 flex items-center justify-center cursor-pointer transition-colors">
                                        <span class="material-icons text-[10px]">expand_more</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div>
                            <label class="text-[11px] font-black text-slate-400 uppercase tracking-widest pl-1 mb-1.5 block">
                                {{ !selectedFeeHasVat ? 'ราคาต่อหน่วย' : (amountMode === 'inclusive' ? 'ราคาต่อหน่วย (รวม VAT)' : 'ราคาต่อหน่วย (ก่อน VAT)') }}
                            </label>
                            <div class="relative flex items-center">
                                <div class="absolute left-4 text-amber-500 font-black text-[10px]">฿</div>
                                <input type="number" [(ngModel)]="newItemAmount" min="0" placeholder="0.00"
                                    class="w-full h-11 pl-8 pr-4 bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-700 rounded-xl text-right text-sm font-black text-slate-800 dark:text-slate-100 outline-none transition-all focus:ring-4 focus:ring-amber-50 focus:bg-white dark:focus:bg-slate-800">
                            </div>
                        </div>
                    </div>

                    <!-- Total Preview -->
                    <div class="pt-6">
                        <div class="p-6 bg-amber-50 dark:bg-amber-900/10 border border-amber-100 dark:border-amber-800/60 rounded-[1.5rem] flex justify-between items-center shadow-sm">
                            <div class="flex items-center gap-3">
                                <div class="w-10 h-10 rounded-xl bg-white dark:bg-slate-800 flex items-center justify-center text-amber-500 shadow-sm border border-amber-100 dark:border-amber-800/30">
                                    <span class="material-icons text-[20px]">calculate</span>
                                </div>
                                <div>
                                    <span class="text-[9px] font-black text-amber-600/70 dark:text-amber-500/70 uppercase tracking-widest block leading-none">ราคารวมรายการ</span>
                                    <span class="text-[11px] font-bold text-slate-400">Subtotal Preview</span>
                                </div>
                            </div>
                            <div class="text-right">
                                <span class="text-2xl font-black text-amber-600 dark:text-amber-400 tracking-tighter">{{ vatPreview.lineTotal | number:'1.2-2' }}</span>
                                <span class="text-xs font-black text-amber-500 ml-1">฿</span>
                            </div>
                        </div>

                        <!-- VAT breakdown -->
                        <div *ngIf="selectedFeeHasVat"
                            class="mt-3 p-4 bg-slate-50 dark:bg-slate-900/50 border border-slate-100 dark:border-slate-700 rounded-2xl text-xs font-bold space-y-2">
                            <div class="flex justify-between text-slate-500 dark:text-slate-400">
                                <span>ราคาต่อหน่วยก่อน VAT</span>
                                <span>{{ vatPreview.unitExclusive | number:'1.2-2' }} ฿</span>
                            </div>
                            <div class="flex justify-between text-slate-500 dark:text-slate-400">
                                <span>VAT {{ vatRateLabel }}% ต่อหน่วย</span>
                                <span>{{ vatPreview.unitVat | number:'1.2-2' }} ฿</span>
                            </div>
                            <div class="border-t border-dashed border-slate-200 dark:border-slate-700 pt-2 flex justify-between text-slate-700 dark:text-slate-200">
                                <span>ยอดก่อน VAT × {{ newItemQuantity || 0 }}</span>
                                <span>{{ vatPreview.lineExclusive | number:'1.2-2' }} ฿</span>
                            </div>
                            <div class="flex justify-between text-slate-700 dark:text-slate-200">
                                <span>VAT รวม</span>
                                <span>{{ vatPreview.lineVat | number:'1.2-2' }} ฿</span>
                            </div>
                            <div class="flex justify-between text-amber-600 dark:text-amber-400 font-black">
                                <span>ยอดรวมทั้งสิ้น</span>
                                <span>{{ vatPreview.lineTotal | number:'1.2-2' }} ฿</span>
                            </div>
                            <p *ngIf="vatPreview.roundingDiff !== 0" class="pt-1 text-[10px] text-rose-500 font-bold leading-relaxed">
                                * ยอดรวมต่อหน่วยหลังถอด VAT ต่างจากที่กรอก {{ vatPreview.roundingDiff | number:'1.2-2' }} ฿ จากการปัดเศษสตางค์
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
